/**
 * Righe tolte nel negozio da un ordine gia' arrivato in Flusia (prodotto rimosso o sostituito in wp-admin).
 * flusia-core non le cancella mai (06 O-14, sync/orders/orderSql.ts SQL_ZERO_REMOVED_LINES): restano con
 * quantita' 0 per lo storico. Nel negozio non si vedono piu', quindi neanche nel CRM.
 * Le righe rimborsate per intero restano visibili (quantita' 0 ma refunded_quantity > 0), come in WooCommerce.
 */
interface LineLike {
  external_line_id?: string | null;
  quantity?: number | string | null;
  refunded_quantity?: number | string | null;
}

export function isRemovedStoreLine(item: LineLike): boolean {
  return !!item.external_line_id && Number(item.quantity ?? 0) === 0 && Number(item.refunded_quantity ?? 0) === 0;
}

export function withoutRemovedStoreLines<T extends LineLike>(items: readonly T[] | null | undefined): T[] {
  return (items ?? []).filter((i) => !isRemovedStoreLine(i));
}
